module.exports = __webpack_public_path__ + "a88bf12293bfe41ef52739298716b83d.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/LabilGrotesk-Bold.woff
// module id = 29
// module chunks = 0 1